<template>
  <div class="lastlogin-row">
    <div class="lastlogin-img">
    <svg width="65" height="65" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" >
      <!-- Created with Method Draw - http://github.com/duopixel/Method-Draw/ -->
      <g>
        <title>background</title>
        <rect x="-1" y="-1" width="202" height="202" id="canvas_background" fill="none"/>
      </g>
      <g>
        <title>Layer 1</title>
        <ellipse fill="#99CB32" stroke="#99CB32" stroke-width="1.5" cx="100.5" cy="100.95313" id="svg_6" rx="91.5" ry="91.5"/>
        <line fill="none" stroke="#FFF" stroke-width="5" x1="49" y1="154.45313" x2="154.51066" y2="48.94246" id="svg_7" stroke-linejoin="undefined" stroke-linecap="undefined"/>
        <text stroke="#FFF" transform="matrix(1.9362200498580933,0,0,1.814814805984497,-43.06612229347229,-38.66550884023309) " xml:space="preserve" text-anchor="start" font-family="Helvetica, Arial, sans-serif" font-size="24" id="svg_1" y="71.65721" x="42.90118" fill-opacity="null" stroke-opacity="null" stroke-width="0" fill="#FFF">{{Date_Now}}</text>
        <text style="cursor: move;" stroke="#FFF" transform="matrix(1.9362200498580933,0,0,1.814814805984497,-43.06612229347229,-38.66550884023309) " xml:space="preserve" text-anchor="start" font-family="Helvetica, Arial, sans-serif" font-size="24" id="svg_2" y="101.41231" x="79.57056" fill-opacity="null" stroke-opacity="null" stroke-width="0" fill="#FFF">{{Month_Now}}</text>
      </g>
    </svg>
    </div>
    <div class="lastlogin-green-font lastlogin-content lastlogin-contentfontsize">
        <div>
            {{today_Day}}
        </div>
        <div>
            上次登入時間：{{lastlogin_Time}}
        </div>
        <div>
            時鐘：{{Time_Now}}
        </div>
    </div>
  </div>
</template>
<style>
  .lastlogin-contentfontsize{
    font-size:1rem;
  }
  .lastlogin-green-font{
    color: #99CB32;
  }

  .lastlogin-img{
    float:left;
    padding: 0 1rem 0 0;
  }
  .lastlogin-content{
    float:left;
    margin:auto;
  }
  .lastlogin-row {
    display: flex;
  }
</style>
<script>
export default {
  data () {
    return {
      today_Day: '星期四',
      lastlogin_Time: '30/11/2019 20：44',
      Time_Now: '31/10/2019 20：01',
      Date_Now: '31',
      Month_Now: '10'
    }
  }
}
</script>
